//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The status of a Scheduled Transaction */
export const FinancialScheduledTransactionStatus = {
    /** Scheduled Transaction is operating normally */
    Active: 0,

    /** Scheduled Transaction completed */
    Completed: 1,

    /** Scheduled Transaction is paused */
    Paused: 2,

    /** Scheduled Transaction is cancelled */
    Canceled: 3,

    /** Scheduled Transaction is failed */
    Failed: 4,

    /** Scheduled Transaction is Past Due */
    PastDue: 5
} as const;

/** The status of a Scheduled Transaction */
export const FinancialScheduledTransactionStatusDescription: Record<number, string> = {
    0: "Active",

    1: "Completed",

    2: "Paused",

    3: "Canceled",

    4: "Failed",

    5: "Past Due"
};

/** The status of a Scheduled Transaction */
export type FinancialScheduledTransactionStatus = typeof FinancialScheduledTransactionStatus[keyof typeof FinancialScheduledTransactionStatus];
